import React, { memo, useCallback, useMemo } from 'react';
import Div from '@/shared/Div';
import Map from '@/components/Map';
import Heading from '@/shared/Heading';
import InformationCard from '@/shared/crisp/InformationCard';
import Container from '@/shared/Container';
import { useProfileContext } from '@/context/profileContext';
import is from '@/utils/is';
import { LOGIN_REDIRECT_TO_QUERY } from '@/constants/app';
import withContentFlags from '@/hoc/withContentFlags';

interface WhyBuyProps {
  title: string;
  list: any[];
}

const WhyBuy = (props: WhyBuyProps) => {
  const { state: profileState } = useProfileContext();
  const { title, list } = props;

  const render = useCallback(
    (item: any, index: number) => {
      if (index === 0 && !profileState.isLoggedIn && is.not.empty.array(item.ctas)) {
        const cta = item.ctas[0];
        item.ctas = [
          {
            ...(cta ?? {}),
            href: `/login?${LOGIN_REDIRECT_TO_QUERY}=${cta?.href}`,
            label: 'Sign in',
          },
        ];
      }
      return <InformationCard key={item.id} dataTestId={`why-buy-${item.id}`} {...item} />;
    },
    [profileState.isLoggedIn],
  );

  const listDeepCopy = useMemo(() => JSON.parse(JSON.stringify(list)), [list]);

  return (
    <Div className="py-s8 md:py-s9 bg-cs-secondary">
      <Container className="flex flex-col gap-s6">
        <Heading level={3} className="text-h-1 md:text-hd-1 text-cm-primary">
          {title}
        </Heading>
        <Map
          className="grid grid-cols-2 md:flex gap-s3 md:gap-s7"
          list={listDeepCopy}
          render={render}
        />
      </Container>
    </Div>
  );
};

export default withContentFlags(memo(WhyBuy));
